
type Props = {
    images: string[]
}

const ImgViewer = ({ images }: Props) => {
    return (
        <div className="grid w-full h-full grid-cols-1 overflow-auto">
            {images.map((image, index) => (
                <img
                    key={index}
                    src={image}
                    alt="exercise"
                    className="object-contain w-full "
                />
            ))}
        </div>
    )
}

export default ImgViewer